import React from 'react';
import { Grid, TextField, FormControlLabel, Checkbox, Typography, Divider, Autocomplete, Box } from '@mui/material';
import { vitalsOptions, cvsOptions, rsOptions, gitOptions, gnsOptions, spineOptionsTypes, expertOpinionOptions } from '../constants/options';

const VitalsAndExamsSection = ({ formData, handleChange, setFormData }) => {
  return (
    <>
      <Typography variant="h6">Vital Signs</Typography>
      <Grid container spacing={2}>
        {["pr", "bp", "spo2", "temp", "ht", "wt"].map((key) => (
          <Grid item xs={6} md={4} key={key}>
            <Autocomplete
              freeSolo
              options={vitalsOptions[key]}
              value={formData[key] || ''}
              onInputChange={(event, newInputValue) => setFormData(prev => ({ ...prev, [key]: newInputValue }))}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={key.toUpperCase()}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {params.InputProps.endAdornment}
                        <Box component="span" sx={{ ml: 1, color: 'text.secondary' }}>
                          {key === 'bp' ? 'mmHg' : key === 'spo2' ? '%' : key === 'temp' ? '°F' : key === 'ht' ? 'cm' : 'kg'}
                        </Box>
                      </>
                    ),
                  }}
                  fullWidth
                />
              )}
            />
          </Grid>
        ))}
      </Grid>
      
      <Box sx={{ mt: 3, mb: 3 }}>
        <Typography variant="h6">Risk Factors / Concerns</Typography>
        <TextField 
          fullWidth 
          value={formData.riskfactors_concerns || ''} 
          onChange={handleChange("riskfactors_concerns")} 
          multiline 
          rows={3} 
        />
      </Box>

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6">General Examination</Typography>
      <Grid container spacing={2}>
        {[
          { key: "conscious", label: "Conscious" },
          { key: "oriented", label: "Oriented" },
          { key: "pallor", label: "Pallor" },
          { key: "febrile", label: "Febrile" },
          { key: "icterus", label: "Icterus" },
          { key: "cyanosis", label: "Cyanosis" },
          { key: "clubbing", label: "Clubbing" },
          { key: "oedema", label: "Oedema" },
        ].map((exam) => (
          <Grid item xs={6} sm={3} key={exam.key}>
            <FormControlLabel
              control={<Checkbox checked={formData[exam.key] || false} onChange={handleChange(exam.key)} />}
              label={exam.label}
            />
          </Grid>
        ))}
      </Grid>
      <TextField 
        fullWidth 
        label="Others" 
        value={formData.general_examination_others || ''} 
        onChange={handleChange("general_examination_others")} 
        multiline 
        rows={2} 
        sx={{ mt: 2 }} 
      />

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6">Systemic Examination / Medical Evaluation</Typography>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={cvsOptions}
            value={formData.cvs || ""}
            onInputChange={(event, newInputValue) => setFormData(prev => ({ ...prev, cvs: newInputValue }))}
            renderInput={(params) => <TextField {...params} label="CVS" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={rsOptions}
            value={formData.rs || ""}
            onInputChange={(event, newInputValue) => setFormData(prev => ({ ...prev, rs: newInputValue }))}
            renderInput={(params) => <TextField {...params} label="RS" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={gitOptions}
            value={formData.git || ""}
            onInputChange={(event, newInputValue) => setFormData(prev => ({ ...prev, git: newInputValue }))}
            renderInput={(params) => <TextField {...params} label="GIT" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={gnsOptions}
            value={formData.gns || ""}
            onInputChange={(event, newInputValue) => setFormData(prev => ({ ...prev, gns: newInputValue }))}
            renderInput={(params) => <TextField {...params} label="GNS" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={spineOptionsTypes}
            value={formData.spine_evaluation || ""}
            onInputChange={(event, newInputValue) => setFormData(prev => ({ ...prev, spine_evaluation: newInputValue }))}
            renderInput={(params) => <TextField {...params} label="Spine Evaluation" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={expertOpinionOptions}
            value={formData.expert_opinion || ""}
            onInputChange={(event, newInputValue) => setFormData(prev => ({ ...prev, expert_opinion: newInputValue }))}
            renderInput={(params) => <TextField {...params} label="Expert(s) Opinion" variant="outlined" fullWidth />}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField 
            fullWidth 
            label="Others Evaluation" 
            variant="outlined" 
            onChange={handleChange("others_evaluation")} 
            value={formData.others_evaluation || ''} 
          />
        </Grid>
      </Grid>
    </>
  );
};

export default VitalsAndExamsSection;
